<template>
  <div>

    <ShopItemsAllCompaniesModal 
      ref="shop-item-table-modal"
      @selected="shop_item_selected"
    />

    <m-row class="align-items-center mb-4 mt-8">
      <m-col sm="6">
        <!-- Additional content can go here -->
      </m-col>

      <m-col sm="6" class="d-flex justify-end">
        <memlist-icon-button
          icon="menu-icon flaticon2-plus"
          :text="$t('INVOICE.ADD_PRODUCT')"
          variant="primary"
          @click="add_row"
        />
      </m-col>
    </m-row>

    
    <div v-for="(row, index) in invoice_items" :key="index">
      <m-row class="invoice-item-row mb-4">
        <m-col lg="3" class="input-with-button">
          <memlist-select-input2
            style="width: 100%;"
            v-model="row.shop_item_id"
            :items="shop_items"
            :title="$t('INVOICE.SELECT_PRODUCT')" 
            layout="vertical"
            validation_type="TEXT"
            :invalid_text="''"
            :info_text="''"
            size="sm"
            @change="handle_product_change(index)"
          />
          <memlist-table-button
            class="mt-6 search-button"
            @click="search_shop_items_clicked(index)"
            svg="/assets/svg/search.svg"
            :tooltip="$t('COMMON.SEARCH')"
          />
        </m-col>

        <m-col lg="3">
          <memlist-text-input
            v-model="row.amount"
            :title="$t('INVOICE.AMOUNT')"
            layout="vertical"
            type="text"
            size="sm"
            placeholder="Enter amount"
            @input="amount_row_changed(index, $event)"
          />
        </m-col>

        <m-col lg="3">
          <memlist-select-input2
            v-model="row.vat_pct"
            :items="vat_options"
            :title="$t('INVOICE.VAT_OPTIONS')"
            layout="vertical"
            size="sm"
            validation_type="TEXT"
          />
        </m-col>

        <m-col lg="2">
          <memlist-text-input
            v-model="row.quantity"
            :title="$t('INVOICE.QUANTITY')"
            layout="vertical"
            type="text"
            size="sm"
            :disabled="false"
          />

        </m-col>

        <m-col lg="1" class="d-flex justify-end">
          <memlist-table-button
            class="mt-6"
            @click="remove_row(index)"
            svg="/assets/svg/trash2.svg"
            :tooltip="$t('COMMON.DELETE')"
          />
        </m-col>
      </m-row>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import ShopItemsAllCompaniesModal from '@/view/pages/ml/shopitem/ShopItemsAllCompaniesModal.vue';

export default {
  name: 'MemberInvoiceAddShopItemTable',
  components: {
    ShopItemsAllCompaniesModal
  },
  emits: ['changed','selected'],
  data() {
    return {
      current_index: 0,
      invoice_items: [],  // Renamed to snake_case
      shop_items: [],  // This will hold the list of available shop items
      vat_options: [
        { value: 0, text: this.$t('PAGES.SHOPITEM.VAT_FREE') },
        { value: 6, text: '6%' },
        { value: 12, text: '12%' },
        { value: 25, text: '25%' },
      ],
    };
  },
  methods: {
    amount_row_changed(index, amount) {
      this.invoice_items[index].amount = amount;
      this.invoice_items = [...this.invoice_items];
      this.$emit('changed', index, this.invoice_items[index]);
    },
    shop_item_selected(item) {
      this.invoice_items[this.current_index].shop_item_id = item.shop_item_id;
      this.invoice_items[this.current_index].amount = item.amount;
      this.invoice_items[this.current_index].vat_pct = item.vat_pct;
      
      this.invoice_items = [...this.invoice_items];

      this.$emit('selected', this.current_index, item);

      this.$refs['shop-item-table-modal'].hide();
    },
    search_shop_items_clicked(index) {
      this.current_index = index;
      this.$refs['shop-item-table-modal'].show();
    },
    add_row() {
      this.invoice_items.push({
        product: null,  // Bound to product selection
        amount: null,
        vat_options: null,
        quantity: 1,  // Default quantity
      });

      console.log('row added');
    },
    async fetch_shop_items() {
      // Replace this with your API request to fetch the shop items
      try {
        const response = await axios.get(`/shop_item/all`);
        if (response.status === 200) {
          this.shop_items = response.data.map(i => ({ value: i.shop_item_id, text: i.name }));
        }
      } catch (error) {
        console.error('Error fetching shop items:', error);
      }
    },
    remove_row(index) {
      this.invoice_items.splice(index, 1);
    },
    open_product_modal(index) {
      // Implement logic to trigger your product selection modal here
      console.log("Open modal for row:", index);
    },
    handle_product_change(index) {
      const selected_product = this.invoice_items[index].product;
      
      if (selected_product) {
        // Set the predefined amount and vat_pct when a shop item is selected
        this.invoice_items[index].amount = selected_product.amount || 0;  // Default to 0 if no amount is predefined
        this.invoice_items[index].vat_options = selected_product.vat_pct || 0;  // Default to 0 if no VAT percentage is predefined
      }
    }
  },
  created() {
    // Example: Fetch shop items from an API and set it to the shop_items array
    this.fetch_shop_items();
  },
 
};
</script>

<style scoped>
.invoice-item-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.input-with-button {
  display: flex;
  align-items: center; /* Align the button and input in the center */
  gap: 8px; /* Optional: adds space between the input and the button */
}

.memlist-select-input2 {
  flex-grow: 1; /* Make the select input take up available space */
}

.search-button {
  margin-top: 0; /* Remove the margin-top on the button to prevent it from jumping to a new line */
  align-self: center; /* Ensure the button is aligned vertically in the center */
}
</style>
